<template>
    <div>
        <section class="section">
            <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/2020_hvc_holiday_giftbox.png?alt=media"></img>
        </section>

        <section class="section is-medium">
            <p class="title is-1 has-text-white">Holiday Surprise Bag Sign Up</p>
            <p class="subtitle is-6 has-text-white">It may take up to 2 business days for me to get back to you, please be patient :)</p>

            <div class="notification is-primary" v-show="msgSentSucceed">
                <button class="delete" @click="msgSentSucceed = false"></button>
                Your form has been sent successfully! Please wait for our reply.
                <font-awesome-icon :icon="['fas', 'smile']" />
            </div>
            <div class="notification is-danger" v-show="msgSentError">
                <button class="delete" @click="msgSentError = false"></button>
                Oh no, something went wrong with the server, please try again a few minutes later.
                <font-awesome-icon :icon="['fas', 'frown']" />
            </div>

            <div class="container">
                <div class="columns">
                    <div class="column">
                        <img src="https://firebasestorage.googleapis.com/v0/b/hiddenvillagecreations-51e08.appspot.com/o/hvc_holiday_flow.png?alt=media" height="100px"></img>
                    </div>
                    <div class="has-text-left column">
                        <div class="field">
                            <label class="label">Name *</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="Jean-Luc Picard" v-model="name" @blur="v$.name.$touch()">
                            </div>
                            <p class="help is-danger" v-if="v$.name.$error">This name is required</p>
                        </div>

                        <div class="field">
                            <label class="label">Email *</label>
                            <div class="control">
                                <input class="input" type="email" placeholder="makeitso@tng.com" v-model="email" @blur="v$.email.$touch()">
                            </div>
                            <p class="help is-danger" v-if="v$.email.$invalid || v$.email.$error">This email is invalid</p>
                        </div>

                        <div class="field">
                            <label class="label">Quantity *</label>
                            <div class="control">
                                <div class="select is-dark">
                                <select v-model="quantity">
                                    <option disabled value="">Please select one</option>
                                    <option>1</option>
                                    <option>2</option>
                                </select>
                                </div>
                            </div>
                            <p class="help is-danger" v-if="v$.quantity.$error">This quantity is required.</p>
                        </div>

                        <div class="field">
                            <label class="label">Home Address *</label>
                            <div class="control">
                                <textarea class="textarea" placeholder="24-593 Federation Drive, San Francisco, CA" v-model="address" @blur="v$.address.$touch()"></textarea>
                            </div>
                            <p class="help is-danger" v-if="v$.address.$error">This home address is required.</p>
                        </div>
                        <div class="field">
                            <label class="label">Postal code *</label>
                            <div class="control">
                                <input class="input" type="postal" placeholder="47s" v-model="postal" @blur="v$.postal.$touch()">
                            </div>
                            <p class="help is-danger" v-if="v$.postal.$error">This postal code is required</p>
                        </div>

                        <div class="field is-grouped is-grouped-right">
                            <div class="control">
                                <button class="button is-primary" @click="sendMsg">Submit</button>
                            </div>
                            <div class="control">
                                <button class="button" @click="reset">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: 'holiday',
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
        name: '',
        email: '',
        address: '',
        quantity: '',
        postal: '',
        msgSentSucceed: false,
        msgSentError: false,
    }
  },
  validations () {
    return {
      name: { required, $lazy: true },
      email: { required, email, $lazy: true },
      address: { required, $lazy: true },
      quantity: { required },
      postal: {required}
    }
  },
  methods: {
    reset() {
        this.name = ''
        this.email= ''
        this.address = ''
        this.quantity = ''
        this.postal = ''
        this.v$.$reset()
    },
    async sendMsg() {
        const result = await this.v$.$validate()
        if (!result) {
            // notify user form is invalid
            return
        }

        var formData = new URLSearchParams();
        formData.append('name', this.name);
        formData.append('email', this.email);
        formData.append('address', this.address);
        formData.append('quantity', this.quantity);
        formData.append('postal', this.postal);

        var authorizationBasic = window.btoa('29c559519b9d490c' + ':' + '9d654e33ac7b9fb5');

        fetch('https://hapi-bh4nw7zela-nn.a.run.app/v1/holiday/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Authorization': 'Basic ' + authorizationBasic
            },
            body: formData.toString()
        }).then(() => {
            this.msgSentSucceed = true
            this.reset()
        }).catch(() => {
            this.msgSentError = true
        })
    }
  }
}
</script>